import { AxiosInstance } from 'axios';

import { NotificationAPIApiFactory } from '@cast/openapi';

import { AXIOS_CONFIGURATION } from '../constants';

export const NotificationsApiAdapter = (client: AxiosInstance) => {
  const generatedApi = NotificationAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  return {
    ackNotifications: generatedApi.notificationAPIAckNotifications,
    listNotifications: generatedApi.notificationAPIListNotifications,
    listDefinitions: generatedApi.notificationAPIListDefinitions,
    listWebhooks: generatedApi.notificationAPIListWebhookConfigs,
    createWebhook: generatedApi.notificationAPICreateWebhookConfig,
    updateWebhook: generatedApi.notificationAPIUpdateWebhookConfig,
    deleteWebhook: generatedApi.notificationAPIDeleteWebhookConfig,
    webhookCategories: generatedApi.notificationAPIListWebhookCategories,
    createSlackConfiguration: generatedApi.notificationAPICreateSlackConfig,
    updateSlackConfiguration: generatedApi.notificationAPIUpdateSlackConfig,
    deleteSlackConfiguration: generatedApi.notificationAPIDeleteSlackConfig,
    testSlackConfiguration:
      generatedApi.notificationAPISendTestSlackConfigNotification,
    testSlackWorkspace:
      generatedApi.notificationAPISendSlackWorkspaceTestNotification,
    listSlackConfigurations: generatedApi.notificationAPIListSlackConfigs,
    listSlackWorkspaces: generatedApi.notificationAPIListSlackWorkspaces,
    listSlackChannels: generatedApi.notificationAPIListSlackChannels,
    deleteSlackWorkspace: generatedApi.notificationAPIDeleteSlackWorkspace,
    slackWorkspacesInstall:
      generatedApi.notificationAPICreateSlackWorkspaceInstall,
    completeSlackWorkspacesInstall:
      generatedApi.notificationAPICompleteSlackWorkspaceInstall,
  };
};
